import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import TaskPopup from "../../Components/Popups/TaskPopup";
import { ADD_TASK } from "../../Constants/reducerEvents";
import Calendar from "./Calendar";

export default function TaskCalendar() {
  const [editPopup, setEditPopup] = useState(false);
  const [clickedTask, setClickTasked] = useState(null);
  const dispatch = useDispatch();
  const editTask = (task) => {
    setClickTasked(task);
    setEditPopup(true);
  };
  const submitNewTask = (task) => {
    if (task) {
      dispatch({ type: ADD_TASK, payload: task });
    }
    setEditPopup(false);
  };
  function getWindowSize() {
    return { width: window.innerWidth, height: window.innerHeight };
  }
  const [windowSize, setWindowSize] = useState(getWindowSize());
  useEffect(() => {
    function handleResize() {
      setWindowSize(getWindowSize());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div style={{ height: "100%" }}>
      <Calendar onTaskClicked={editTask} windowSize={windowSize} />
      <TaskPopup
        open={editPopup}
        onClose={submitNewTask}
        initialTask={clickedTask}
      />
    </div>
  );
}
